export const CUSTOMERS_LIST_SEARCH = "customers-list-search";
export const DASHBOARD_SEARCH = "dashboard-search";

export const NEW_CUSTOMER_REVIEW = "new-customer-review";

// a key to set in localStorage the current url before logging out the user in AuthProvider.tsx
// after logout, the user will be redirected to /logout
export const REDIRECT_TO_AFTER_LOGOUT_KEY = "redirect-to-after-logout";
